import API from "./API";
import { isRedirectAuth } from '../auth/redirectEntry';
import { sessionError } from '../auth/sessionTransition';

// Requires the opt-in isolated client and a lock-owned attempt; never falls back
// to the legacy API instance with Admin's unsafe response interceptor.
export const redirectSession = (input, { client, attempt, signal } = {}) => {
  if (!input || !isRedirectAuth(input.auth) || !client || !attempt) {
    if (input) input.auth = null
    return Promise.reject(sessionError('ENTRY_UNAVAILABLE'))
  }
  const body = { auth: input.auth }
  input.auth = null
  return Promise.resolve().then(() => client.post('/redirect-session', body, { attempt, signal }))
    .then(response => {
      const marker = response.data && response.data.auth_token
      if (typeof marker !== 'string' || !/^[a-f0-9]{64}$/i.test(marker)) throw sessionError('SESSION_INVALID_RESPONSE')
      return { auth_token: marker }
    })
    .finally(() => { body.auth = null })
}

export const login = (username, password) => {
  return API.post('/login', {username, password})
}

export const logout = () => {
  return API.post('/logout')
}

export const signin = (code, id_token, session_state, state) => {
  return API.post('/signin', { code, id_token, session_state, state })
}

export const forgottenPassword = (email) => {
  return API.post('/forgot-password', { email })
}

export const resetPassword = (email, password, token) => {
  return API.post('/reset-password', { email, password, token })
}

export const me = () => {
  return API.get('/me', {  })
}

export const validate = () => {
  return API.get('/validate', {})
}

export const version = () => {
  return API.get('/version', {})
}

export const existToken = (token) => {
  return API.post('/exist-token', { token})
}
